const onlyLoggedOut = ({ user }) => {
  if (!user || !user.id) {
    return { status: 200 };
  }
  return { status: 404 };
};

export default onlyLoggedOut;
